import DefinitionDialogForm from 'Features/Definitions/DefinitionDialogForm';
import { DefinitionState } from 'Models/Definitions/@types';
import { WeeklyTechState } from 'Models/WeeklyTech/@types';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { ReduxStore } from 'stores';
import WeeklyTechDialogForm from 'Features/WeeklyTech/WeeklyTechDialogForm';

type StoreSelections = Pick<DefinitionState, 'dialogFormProps'>
type WeekTechStoreSelection = Pick<WeeklyTechState, 'weeklyDialogFormProps'>
export interface DialogContainersProps { }

const DialogContainers: FC<DialogContainersProps> = (props) => {

    const { dialogFormProps } = useSelector<ReduxStore, StoreSelections>(({ Definitions: { dialogFormProps } }) => ({ dialogFormProps }));
    const { weeklyDialogFormProps } = useSelector<ReduxStore, WeekTechStoreSelection>(({ WeeklyTech: { weeklyDialogFormProps } }) => ({ weeklyDialogFormProps }));
    return (
        <>
            {dialogFormProps.open ? <DefinitionDialogForm {...dialogFormProps} /> : null}
            {weeklyDialogFormProps.open ? <WeeklyTechDialogForm {...weeklyDialogFormProps} /> : null}
        </>
    )
}

export default DialogContainers